import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import {
  Grid,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import SearchIcon from "@material-ui/icons/FindReplace";
import {appConstants} from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1,
      paddingLeft: '15px'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 100
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 1
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
      marginTop: "0px",
      width: '95%'
  },
    Grid: {
    flexBasis: "14px"
    }
});

function SearchComponent(props) {
  let {
    classes,
      user,
      airlines,
      airports,
      selectChange,
      onSearch,
      AirportCode,
      AirlineId,
      reorderOptions,
      reorder
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item md={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
                options={airlines.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                selectedOption={AirlineId}
                handleSelectChange={(e, name) => selectChange(e, name)}
                // selectLabel={"Airlines"}
                disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                name={"AirlineId"}
            />
            {/*<Select*/}
              {/*value={AirlineId}*/}
              {/*disabled={user.AppRole === appConstants.ROLES.AIRLINE}*/}
              {/*onChange={selectChange}*/}
              {/*input={<Input name="airline" id="airline-label-placeholder" />}*/}
              {/*// displayEmpty*/}
              {/*name="AirlineId"*/}
              {/*className={classes.selectEmpty}*/}
            {/*>*/}
              {/*<MenuItem value="-1">All Airlines</MenuItem>*/}
              {/*{airlines.map((option, i) => (*/}
                {/*<MenuItem*/}
                  {/*key={i}*/}
                  {/*value={option.AirlineId}*/}
                  {/*className={classes.select}*/}
                {/*>*/}
                  {/*{option.Airline}*/}
                {/*</MenuItem>*/}
              {/*))}*/}
            {/*</Select>*/}
          </FormControl>
        </Grid>

        <Grid item md={3}>
          <FormControl
              className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airports
            </InputLabel>
            <AutocompleteSelect
                options={airports.map(option => ({ value: option.Code, label: option.Name }))}
                selectedOption={AirportCode}
                handleSelectChange={(e, name) => selectChange(e, name)}
                // selectLabel={"Airports"}
                disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                name={"AirportCode"}
            />
            {/*<Select*/}
                {/*value={AirportCode}*/}
                {/*disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}*/}
                {/*onChange={selectChange}*/}
                {/*input={<Input name="airportCode" id="airport-label-placeholder" />}*/}
                {/*name="AirportCode"*/}
                {/*className={classes.selectEmpty}*/}
            {/*>*/}
              {/*<MenuItem value="-1">All Airports</MenuItem>*/}
                {/*{airports.map((option, i) => (*/}
                    {/*<MenuItem*/}
                        {/*key={i}*/}
                        {/*value={option.Code}*/}
                        {/*className={classes.select}*/}
                    {/*>*/}
                        {/*{option.Name}*/}
                    {/*</MenuItem>*/}
                {/*))}*/}
            {/*</Select>*/}
          </FormControl>
        </Grid>
        <Grid item md={3}>
          <FormControl
              className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Re-Order Level
            </InputLabel>
            <AutocompleteSelect
              options={reorderOptions.map(option => ({value: option.value, label: option.name}))}
              name={"reorder"}
              selectedOption={reorder}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
          </FormControl>
        </Grid>
        <Grid item md={3}>
          <div style={{ float: 'left'}}>
              <Button color={'regional'} onClick={() => onSearch()}>
                  <SearchIcon/> Search
              </Button>
          </div>

        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(SearchComponent);



// WEBPACK FOOTER //
// ./src/Regional-Views/WalletReport/SearchPanel.jsx